import 'arrive';

var totalSteps, submitButton, productButtons, addWindowButton, viewCartButton, cartProperties, optionTags, quantity = 1, windowCount = 0, windowPrices = [], model, partPrice = 0.00, partId, trimRequired = false, trimLength = null, trimCustom = 0, trimThickness = null, trimPrice = 0.00, trimId = null;

/**
 * Helpers
 */
function updateEditButtons() {
    $('.product-options__step').each(function() {
        var thisStep = $(this);
        var option = thisStep.find('input:checked');
        var editButton = thisStep.find('.product-options__edit-step');
        var label = '';

        option.each(function(index) {
            var thisOption = $(this);
            var thisValue = thisOption.siblings('div').text();

            label += (thisValue ? (index > 0 ? ' / ' : '') + thisValue : '');
        });

        editButton.html(label);
    });
}

function updateSelected() {
    $('.mw-option input').each(function() {
        if ($(this).is(':checked')) {
            $(this).closest('.mw-option').removeClass('is-invalid');
        }
    });
}

function validateStep() {
    var currentStep = $('.product-options__current-step');
    var required = $('.product-options__current-step .mw-option--required:not(.mw-hidden)');
    var lastStep = currentStep.data('step') === totalSteps;
    var invalid = [];

    required.each(function() {
        if ($(this).hasClass('mw-option--type-number')) {
            if (!$(this).find('input').val()) {
                invalid.push($(this).attr('id')); 
            }
        } else {
            if (!$(this).find('.mw-option__value--selected').length) {
                invalid.push($(this).attr('id')); 
            }
        }
    });

    if (invalid.length) {
        currentStep.find('.mw-option').removeClass('is-invalid');

        invalid.forEach(function(id) {
            $('#' + id).addClass('is-invalid is-flash');
        });

        setTimeout(function() {
            $('.mw-option--required').removeClass('is-flash');
        }, 1000)
    }

    // If all options are valid, go to next step.
    if( !invalid.length && !lastStep ) {
        nextStep(currentStep);
    }

    // If all options are valid on the last step, add to cart.
    if( !invalid.length && lastStep ) {
        quantity = $('#quantity').val();
        addToCart(partId, quantity, trimId, cartProperties);
    }
}

function resetValidation() {
    $('.mw-option--required').removeClass('is-invalid');
}

function showCompletedButtons() {
    productButtons.addClass('is-swapping');

    // Hide edit buttons
    $('.product-options__step').addClass('is-disabled');

    setTimeout(function() {
        addWindowButton.css('display', 'inline-block');
        viewCartButton.css('display', 'inline-block');
        submitButton.hide();

        productButtons.removeClass('is-swapping');
    }, 400);
}

function hideCompletedButtons() {
    productButtons.addClass('is-swapping');

    setTimeout(function() {
        addWindowButton.hide();
        viewCartButton.hide();
        submitButton.show();
        
        productButtons.removeClass('is-swapping');
    }, 400);
}

function nextStep(currentStep) {
    var nextStep = currentStep.next('.product-options__step');
    var nextLabel = nextStep.find('.mw-option--type-text h5').text();

    // Modify current step
    currentStep.removeClass('product-options__current-step');
    currentStep.addClass('product-options__completed-step');

    // Modify next step
    nextStep.addClass('product-options__current-step');

    // Modify submit button
    if( nextStep.data('step') === totalSteps ) {
        updateSubmit();
    } else {
        updateSubmit('Confirm ' + nextLabel);
    }

    resetValidation();
    calculateOptions();
}

function editStep(editButton) {
    var thisStep = editButton.parent();
    var futureSteps = thisStep.nextAll('.product-options__step');
    var thisLabel = thisStep.find('.mw-option--type-text h5').text();

    // Hide future steps
    futureSteps.removeClass('product-options__current-step product-options__completed-step');

    // Show this step
    thisStep.removeClass('product-options__completed-step');
    thisStep.addClass('product-options__current-step');

    // Update submit button
    updateSubmit('Confirm ' + thisLabel);

    calculateOptions();
}

function updateSubmit(label) {
    label = (label ? label : 'Complete your order');
    submitButton.removeClass('disabled');
    submitButton.html(label);
}

function calculateOptions() {
    var productTotals = $('.product-totals.is-user');
    var currentStep = $('.product-options__current-step').data('step');

    // Stop execution if user is not logged in
    if( !productTotals.length ) {
        return false;
    }

    // If last step, locate SGI Part based on options
    if( currentStep === totalSteps ) {
        findPart();
    } else {
        hideTotals();
        hideContact();
    }
}

function addAnotherWindow() {
    var windowSet = $('.product-options__window').closest('.product-options__step');
    var currentWindowButton = windowSet.find('.product-options__edit-step');

    $('.product-options__step').removeClass('is-disabled');

    // Create duplicate of button for windows added to cart
    editStep(currentWindowButton);

    // Reset options
    windowSet.find('input').prop('checked', false);
    windowSet.find('.mw-option__value--selected').removeClass('mw-option__value--selected');

    // Increase window count
    windowCount++;

    resetTrim();
    hideCompletedButtons();
}

function resetTrim() {
    $('input[name*="Trim"][value="No"]').trigger('click');
}

/**
 * Add to Cart
 */
function addToCart(productId, quantity, trimId, properties = {}) {
    if( !productId || !quantity ) {
        updateSubmit('No matching part found.');
        submitButton.addClass('disabled');
        hideTotals();
        showContact();
        return false;
    }

    let items = [
        {
            quantity: quantity,
            id: productId,
            properties: properties
        }
    ]

    if (trimId && windowCount < 1) {
        items.push({
            quantity: 1,
            id: trimId
        });
    }

    $.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: {items},
        beforeSend: addToCartPending,
        error: addToCartFailed,
        success: function(data) {
            setTimeout(addToCartSuccess, 500);
        }
    });
}

function addToCartPending() {
    submitButton.html('Adding to cart');
    submitButton.addClass('is-pending');
}

function addToCartSuccess() {
    submitButton.html('Added to cart');
    submitButton.removeClass('is-pending');
    submitButton.addClass('is-success');
    
    updateCart();

    setTimeout(function() {
        showCompletedButtons();
    }, 1500);

    setTimeout(function() {
        submitButton.removeClass('is-success');
    }, 2000);
}

function addToCartFailed() {
    submitButton.html('Failed. Try again?');
    submitButton.removeClass('is-pending');
}

/**
 * Build options on load, initialized by hulkcode.js
 */
function buildOptions() {
    var option = $('.mw-option');
    var currentStep = 1;

    // Set globals
    totalSteps = $('.mw-option--type-text').length;

    // Loop over all options and build structure
    option.each(function() {
        var thisOption = $(this);
        var thisLabel = $(this).find('.mw-text');
        var values = thisOption.find('.mw-option__value');
        var tooltip = thisOption.find('.mw-tooltip--icon');
        var isRadio = thisOption.hasClass('mw-option--type-radio');
        var isSwatch = thisOption.hasClass('mw-option--type-swatch');
        var isSection = thisOption.hasClass('mw-option--type-text');
        var circleRadios = true;
        
        // Modify value
        values.each(function() {
            var thisValue = $(this).find('.mw-stack__item--fill');
            var thisValueLabel = $(this).find('.mw-option__value-text');

            // Modify radio
            if (isRadio) {
                if (values.length <= 2) {
                    thisValue.addClass('is-square');
                }

                // Check length of option text
                thisValue.each(function() {
                    if ($(this).find('.mw-text').text().length >= 3) {
                        circleRadios = false;
                        return false;
                    }
                });
            }

            // Modify swatch
            if (isSwatch) {
                var thisContainer = thisValue.find('.mw-option__swatch-media');
                var thisImage = thisValue.find('.mw-option__swatch-image');

                // Move label inside swatch
                if (thisImage) {
                    thisContainer.append(thisValueLabel.text());
                    thisValueLabel.remove();
                }
            }
        });

        // Add circle class if all radios are less than 3 characters
        if (circleRadios) {
            thisOption.find('.mw-stack__item--fill').addClass('is-circle');
            thisOption.find('.mw-stack__item--fill').removeClass('is-square');
        }

        // Remove tooltip img
        tooltip.each(function() {
            var thisTooltip = $(this);
            var thisParent = thisTooltip.parent();

            thisTooltip.find('svg').remove();
            thisTooltip.appendTo(thisTooltip.closest('.mw-stack'));
            thisParent.remove();
        });

        // Modify text fields into sections + hide input
        if (isSection) {
            var thisLabelValue = thisLabel.text().replace('Section - ', '');
            var stepWrapper = $('<div class="product-options__step' + (currentStep === 1 ? ' product-options__current-step' : '') + '" data-step="' + currentStep + '"></div>');
            var isWindowStep = thisLabelValue.toLowerCase().indexOf('window') !== -1;

            // Add section heading
            thisLabel.empty().append('<span class="preheading">Step ' + currentStep + '</span><h5>' + thisLabelValue + '</h5>');

            // Hide input
            thisOption.find('input').hide();

            // Create section for options
            stepWrapper.insertAfter(thisOption).append(thisOption.nextAll('.mw-option').addBack()).appendTo('.mw-apo-container').append('<button type="button" class="product-options__edit-step"></button>');

            if( isWindowStep ) {
                // Add window wrapper
                stepWrapper.find('.mw-option--type-text').nextAll('.mw-option').wrapAll('<div class="product-options__window"></div>');

                // Add quantity to window wrapper
                $('.product-quantity').appendTo($('.product-options__window')).addClass('is-right');

                // Add heading before window wrapper
                $('<h6 class="product-options__window-heading uppercase">Add a window</h6>').insertBefore($('.product-options__window'));
            }

            thisOption.find('input').closest('.mw-stack__item').remove();

            // Increment step
            currentStep++;
        }
    });

    // Listen for input changes and build edit button
    $('.mw-option input').on('change', function() {
        updateSelected();
        updateEditButtons();
        calculateOptions();
        buildTags();
        findTrim();
    });

    // Add button label
    if( totalSteps > 1 ) {
        var buttonLabel = $('.product-options__current-step h5').text();
        updateSubmit('Confirm ' + buttonLabel);
    }

    // Listen for edit button click
    $('.product-options__edit-step').on('click', function() {
        editStep($(this));
    });

    // Listen for add window click
    addWindowButton.on('click', addAnotherWindow);

    // Remove classes
    $('#product-submit').removeClass('mw-apo-add-to-cart-hide mw-apo-buy-it-now-hide');
    $('.mw-apo-add-to-cart-cloned').remove();
    $('.mw-option__value--has-title').removeClass('mw-option__value--has-title');

    // Show options
    $('#product-form').css('opacity', 1);
}

function buildTags() {
    var tags = ['model-' + model];

    $(".mw-option__control:checked").each(function() {
        var thisOption = $(this);
        var thisName = thisOption.closest('.mw-option').find('> .mw-stack > .mw-stack__item .mw-text--style-strong').text();
        var thisValue = thisOption.siblings('.mw-option__value-title, .mw-option__swatch-media').text();
        var thisValueTag = thisValue.trim().replaceAll(/[\W_]+/g, '-').toLowerCase();

        switch (thisName) {
            case 'Wheel Base':
                tags.push('wheel-' + thisValueTag);
                cartProperties[thisName] = thisValue;
                break;
            case 'Trim Required':
                (thisValueTag == 'yes' ? trimRequired = true : trimRequired = false);
                break;
            case 'Trim Length':
                trimLength = thisValueTag;
                break;
            case 'Trim Thickness':
                trimThickness = thisValueTag;
                break;
            default:
                tags.push(thisValueTag);
                cartProperties[thisName] = thisValue;
        }
    });

    $('input[type="number"]').each(function() {
        var thisOption = $(this);
        var thisNameElement = thisOption.closest('.mw-option').find('> .mw-stack > .mw-stack__item .mw-text--style-strong');
        var thisName = thisNameElement.text();
        var thisValue = parseInt(thisOption.val());

        if (thisName == 'Custom Length') {
            thisNameElement.text('Custom Length (M)');

            if (thisValue > 0) {
                trimCustom = thisValue;
            } else {
                trimCustom = 0
            }
        }
    });

    // Concat all tags into string.
    // This is used later on when finding an SGI part.
    optionTags = tags.join();
}

/**
 * Search across all products for the matching SGI Part.
 * Products are filtered based on a series of tags relating to each option.
 * The values of the matching part are then stored for later.
 */
function findPart() {
    if( !optionTags ) {
        updateSubmit('Unable to check database for part.');
        hideTotals();
        return false;
    }

    $.getJSON('/search/suggest.json', {
        'q': optionTags,
        'resources': {
            'type': 'product',
            'limit': 1,
            'options': {
                'unavailable_products': 'hide',
                'fields': 'tag'
            }
        }
    }).done(function(response) {
        var part = response.resources.results.products;

        if (!part.length || !model) {
            updateSubmit('No matching part found.');
            submitButton.addClass('disabled');
            hideTotals();
            showContact();
        } else {
            part = part[0];

            partPrice = parseFloat(part.price);

            // Fetch default variant for Part
            $.getJSON('/products/' + part.handle + '.js').done(function(product) {
                partId = product.variants[0].id;
                cartProperties['Part No'] = product.variants[0].sku;

                // Add window price to array
                windowPrices[windowCount] = partPrice * $('#quantity').val();
            }).fail(function() {
                updateSubmit('Failed to check database for variant.');
                submitButton.addClass('disabled');
            }).always(showTotals);
        }
    }).fail(function() {
        updateSubmit('Failed to check database for part.');
        submitButton.addClass('disabled');
        hideTotals();
    });
}

/**
 * Trim variant ID is determined based on options selected.
 * Trim variant is then added to cart alongside part.
 */
 function findTrim() {
    if( !trimRequired || !trimLength || !trimThickness) {
        trimPrice = 0.00;
        return false;
    }

    let variantTitle = null, productHandle = null;

    if (trimLength == 'custom-length') {
        variantTitle = trimCustom;
    } else {
        variantTitle = 'Full 50m Roll';
    }

    switch (trimThickness) {
        case 'small':
            productHandle = 'small-trim';
            break;
        case 'large':
            productHandle = 'large-trim';
            break;
        case 'ex-large':
            productHandle = 'ex-large-trim';
            break;
        default:
            trimPrice = 0.00;
            return false;
    }

    $.getJSON('/search/suggest.json', {
        'q': variantTitle,
        'resources': {
            'type': 'product',
            'options': {
                'unavailable_products': 'hide',
                'fields': 'variants.title'
            }
        }
    }).done(function(response) {
        var trim = response.resources.results.products;

        if (!trim.length) {
            trimPrice = 0.00;
        } else {
            // Filter to correct trim
            if (trim.length > 1) {
                for (var i = 0; i < trim.length; i++) {
                    if (trim[i].handle === productHandle) {
                        trimPrice = trim[i].variants[0].price;
                        trimId = trim[i].variants[0].id;
                        break;
                    }
                }
            } else {
                trimPrice = trim[0].variants[0].price;
                trimId = trim[0].variants[0].id;
            }
        }
    });
}

/**
 * Show all totals
 */
function showTotals() {
    var productTotals = $('.product-totals.is-user');
    var windowsRow = $('.product-totals__windows');
    var totalPrice = 0.00;

    // Add visible class
    productTotals.addClass('is-displayed');
    windowsRow.html('');

    // Calculate window prices
    windowPrices.forEach(function(price, index) {
        // Apply discount
        if (window.tierDiscount) {
            const percentage = parseFloat((window.tierDiscount * .100 / 10).toFixed(3))
            price = price - (price * percentage)
        }

        windowsRow.append('<div class="product-totals__row"><h6 class="uppercase">Window ' + ++index + '</h6>' + '<span class="price">' + '£' + price.toFixed(2) + '</span></div>');
        totalPrice += price;
    });

    if (trimPrice) {
        windowsRow.append('<div class="product-totals__row"><h6 class="uppercase">Trim</h6>' + '<span class="price">' + '£' + parseFloat(trimPrice).toFixed(2) + '</span></div>');
        totalPrice += parseFloat(trimPrice);
    }

    // Add total price to element
    productTotals.find('.total .price').text('£' + totalPrice.toFixed(2));
}

/**
 * Hide all totals
 */
function hideTotals() {
    var productTotals = $('.product-totals.is-user');
    productTotals.removeClass('is-displayed');
}

/**
 * Show contact text
 */
function showContact() {
    $('#product-contact').show();
}

/**
 * Hide contact text
 */
function hideContact() {
    $('#product-contact').hide();
}

/**
 * Product Init
 */
function productInit() {
    submitButton = $('#product-submit');
    productButtons = $('.product-buttons');
    addWindowButton = $('#product-add-window');
    viewCartButton = $('#product-view-cart');
    cartProperties = {
        'Part No': '',
        'Model': $('.product-main').data('handle')
    };
    model = $('.product-main').data('model');

    // Submit click event
    submitButton.on('click', function(e) {
        e.preventDefault();
        validateStep();
    });
}

function productGallery() {
    const gallery = $('.product-gallery__slider');

    if( !gallery.length ) {
        return false;
    }

    const thumbs = $('.product-gallery__thumbnails');
    const thumb = thumbs.find('img');

    // Using beforeChange event instead of asNavFor due to infinite bug
    gallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        thumbs.slick('slickGoTo', nextSlide);
    });

    gallery.slick({
        arrows: true,
        prevArrow: '<button type="button" class="gallery-prev gallery-control"></button>',
        nextArrow: '<button type="button" class="gallery-next gallery-control"></button>',
        draggable: true,
    });

    thumbs.slick({
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        draggable: true,
        variableWidth: true,
        asNavFor: gallery,
        infinite: false,
        focusOnSelect: true
    }); 
}

function productEnquiry() {
    const enquiry = $('#product-enquiry');
    
    if( !enquiry.length ) {
        return false;
    }

    const enquireButton = $('#product-enquire');
    const currentTopic = $('h1').text();

    // Update topic to match current product
    $('#product-enquiry-topic').val(currentTopic);

    // Listen for enquire button click
    enquireButton.on('click', function() {
        $('html, body').animate({
            scrollTop: enquiry.offset().top - 200
        }, 500);
    });
}

$(document).ready(function() {
    productGallery();
    productEnquiry();
    productInit();

    $('#product-form').arrive('.mw-apo-container', buildOptions);
});